import { render, staticRenderFns } from "./YingBaby.vue?vue&type=template&id=42115251&scoped=true"
import script from "./YingBaby.vue?vue&type=script&lang=js"
export * from "./YingBaby.vue?vue&type=script&lang=js"
import style0 from "./YingBaby.vue?vue&type=style&index=0&id=42115251&prod&scoped=true&lang=css"
import style1 from "./YingBaby.vue?vue&type=style&index=1&id=42115251&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42115251",
  null
  
)

export default component.exports